import { render } from "./SinkronisasiShow.vue?vue&type=template&id=16286da8"
import script from "./SinkronisasiShow.vue?vue&type=script&lang=js"
export * from "./SinkronisasiShow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__